export default "__VITE_ASSET__Cw1JA7qg__"